export const trMessages = {
  "errorOccurred": "Bir hata oluştu. Sayfayı yenileyin.",
  "archiveFragmentUnavailable": "Bu kamerada istenen arşiv bölümü mevcut değil",
  "analyticsZonesHints": "Analitik bölgelerin düzenlenmesine yönelik ipuçları",
  "addPointToZone": "Bölgeye nokta eklemek için videoya tıklayın.",
  "removePointFromZone": "Geçerli bölgeden bir noktayı kaldırmak için o noktaya tıklayın.",
  "removeAllPointsFromZone": "Geçerli bölgedeki tüm noktaları kaldırmak için \"Temizle\" düğmesine basın.",
  "movePoint": "Noktanın yerini değiştirmek için fareyi noktada basılı tutun ve taşıyın.",
  "editZonesIndividually": "Tüm bölgeler aynı anda düzenlenemez, sadece tek tek.",
  "selectZoneToEdit": "Düzenlemek için listeden bir bölge seçin. Bölge renklerinin kaydedilmediğini unutmayın.",
  "maxPointsInZone": "Bir bölgede en fazla 100 nokta olabilir.",
  "acceleratedVideo": "Hızlandırılmış video",
  "analyticsZone": "Analitik bölge",
  "availableZones": "Mevcut bölgeler",
  "showAll": "Hepsini göster",
  "sensitivity": "Hassasiyet",
  "deleteAllPointsInZone": "Geçerli bölgedeki tüm noktaları sil",
  "refreshPage": "Sayfayı yenileyin",
  "from": "Başlangıç",
  "to": "Bitiş",
  "download": "İndir",
  "cancel": "İptal",
  "clean": "Temizle",
  "saveAllZones": "Tüm bölgeleri kaydet",
  "save": "Kaydet",
  "showHelp": "Yardımı göster",
  "zoomOutArchiveScale": "Arşiv ölçeğini uzaklaştır",
  "zoomInArchiveScale": "Arşiv ölçeğini yakınlaştır",
  "goToCurrentMoment": "Şu ana git",
  "archiveCalendar": "Arşiv takvimi",
  "goToLiveStream": "Canlı yayına git",
  "rewindBack15s": "15 saniye geri sar",
  "launch": "Başlat",
  "pause": "Duraklat",
  "fastForward15s": "15 saniye ileri sar",
  "ptzControl": "PTZ kontrolü",
  "takeScreenshot": "Ekran görüntüsü al",
  "videoAnalysisZones": "Video analiz bölgeleri",
  "playbackSpeed": "Oynatma hızı",
  "downloadArchive": "Arşivi indir",
  "volume": "Ses",
  "settings": "Ayarlar",
  "streams": "Akışlar",
  "noDelayStream": "Gecikmesiz canlı yayın",
  "fullscreen": "Tam ekran",
  "close": "Kapalı",
  "confirm": "Onayla",
  "alertMessage": "Yöneticinizle iletişime geçin.",
  "alertDialogTitle": "Mesaj",
  "confirmDialogTitle": "İşlemi onayla",
  "promptDialogTitle": "Dikkat",
  "deleteRow": "Satırı sil",
  "addRow": "Satır ekle",
  "addRowTitle": "Satır ekle",
  "selectFromList": "Listeden seçin",
}
